import styled from 'utils/emotion';

export const PageBuilderSocialsStyled = styled('div')({});
